// @core/api/endpoints/workflow/list_node_types.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListNodeTypesRequest,
  ListNodeTypesResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * List node types
 * Returns all available node types for the visual editor. Supports filtering by category, product, and built-in status.
 */
export async function ListNodeTypes(
  params?: ListNodeTypesRequest,
  options?: RequestOptions
): Promise<ListNodeTypesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/node-types`;
  const requestOptions = options;
  return client.get<ListNodeTypesResponse>(requestPath, { ...requestOptions, params });
}
